/**
 * Normalizes image fields from API payloads (string URL vs nested `{ url }` etc.).
 */
export function resolveAssetUrl(raw: unknown): string | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "string") {
    const s = raw.trim();
    return s || undefined;
  }
  if (typeof raw === "object") {
    const o = raw as Record<string, unknown>;
    for (const key of ["url", "uri", "src", "icon", "img", "imageUrl", "image_url"]) {
      const v = o[key];
      if (typeof v === "string" && v.trim()) return v.trim();
    }
  }
  return undefined;
}
